import * as React from "react";
import { Stack, Text } from "@chakra-ui/react";

import Crown from "components/Chakra/Icons/Crown";
import Success from "components/Chakra/Icons/SuccessCircle";
import Cross from "components/Chakra/Icons/XCircle";

const UserBadge: React.FC<{ type: "premium" | "checked" | "unchecked" }> = ({
  type,
}) => {
  let background = "ud-grey-100";
  let icon = <Cross fillWith="ud-grey-600" boxSize="10px" />;
  let color = "ud-grey-600";
  let message = "Neprověřený";
  if (type === "premium") {
    background = "ud-yellow-300";
    icon = <Crown fillWith="ud-black" boxSize="10px" />;
    color = "ud-black";
    message = "Premium profil";
  } else if (type === "checked") {
    background = "ud-green-100";
    icon = <Success fillWith="ud-success" boxSize="10px" />;
    color = "ud-success";
    message = "Prověřený";
  }

  return (
    <Stack
      direction="row"
      bgColor={background}
      align="center"
      spacing="4px"
      borderRadius="4px"
      px="6px"
      py="2px"
      h="20px"
    >
      {icon}
      <Text fontWeight="bold" variant="small_1" color={color} flexWrap="nowrap">
        {message}
      </Text>
    </Stack>
  );
};

export default UserBadge;
